import Vue from 'vue'
import VueRouter from 'vue-router'
import Preview from '../views/Preview.vue'
// import Document from '../views/Document.vue'
// import Develop from '../views/Develop.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/document/:moduleId?',
    name: 'Document',
    component: () => import(/* webpackChunkName: "document" */ '../views/Document.vue')
  },
  {
    path: '/preview/:pageid/:inPageid?',
    name: 'Preview',
    component: Preview
  },
  {
    path: '/develop/:pageid/:schemaType?',
    name: 'Develop',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "develop" */ '../views/Develop.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
let nextRouter = null,toRouter = null; 
router.beforeEach((to, from, next) => {
  console.log("🚀 ~ file: index.js ~ line 28 ~ router.beforeEach ~ from", from)
  console.log("🚀 ~ file: index.js ~ line 28 ~ router.beforeEach ~ to", to)
  if(to.path!="/"){
    nextRouter = next;
    toRouter = to;
  }else{
    // nextRouter();
    const previewId = IDM&&IDM.url.queryObject().previewId;
    if(previewId){
      router.replace({ path: `/preview/${previewId}` })
    }
    return;
  }
  // ...
  next();
  // debugger
  //解决如果是当前路由不变但是参数变了也要刷新，比如解决：window.localhost.href 跳转当前页无效的问题
  if((to.name!="Preview"&&to.name==from.name&&from.name)||(to.name=="Preview"&&to.params.pageid!=from.params.pageid&&from.params.pageid)){
    window.location.reload();
  }
})
router.onError((error) => {
  console.log("🚀 ~ file: index.js:47 ~ router.onError ~ error:", error)
  if(nextRouter){
    nextRouter();
  }
})
// router.beforeEach((to, from, next) => {
//   // ...
//   alert(JSON.stringify(to))
// })
export default router
